import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getTranslation } from '../../../translations/translations';

const CountdownMessage = styled.div`
  text-align: center;
`;

const CountDownSticker = styled.p`
  display: inline-block;
  margin: 0 0 0.5em;
  padding: 0.3em 1em;
  color: #0171c4;
`;

const GridItemCountdownMessage = ({ isFlashSale }) => (
  <CountdownMessage className={'countdownMessage'}>
    {isFlashSale && (
      <CountDownSticker className={'countdownSticker'}>
        <strong
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: getTranslation('countdownSaleTranslation') }}
        />
      </CountDownSticker>
    )}
  </CountdownMessage>
);

GridItemCountdownMessage.propTypes = {
  isFlashSale: PropTypes.bool
};

GridItemCountdownMessage.defaultProps = {
  isFlashSale: false
};

export default GridItemCountdownMessage;
